<div>
  <kendo-dialog *ngIf="dialogOpened" [minWidth]="250" [width]="450">

    <div *ngIf="offerResponse.errorMessage">
      <div style="font-size: 18px; line-height: 1.3em;">
        <span class="k-icon k-i-exclamation-circle"></span> Request error
      </div>

      <p style="margin: 30px; text-align: center;">
        {{ offerResponse.errorMessage }}
      </p>      
    </div>

    <div *ngIf="offerResponse.saleOfferRequestCode">
      <p style="margin: 30px; text-align: center;">
        Net price: {{ offerResponse.saleOfferTotalNetPrice | number:'1.2-2' : currLng }} {{ offerResponse.currency }}
        <br>
        Gross price: {{ offerResponse.saleOfferTotalGrossPrice | number:'1.2-2' : currLng }} {{ offerResponse.currency }}
        <br>
        Request: {{ offerResponse.saleOfferRequestCode }}
      </p>
    </div>

    <kendo-dialog-actions>
      <button (click)="newRequest()" *ngIf="offerResponse.saleOfferRequestCode"
          kendoButton primary="true" i18n="Dialogs|'New request' button">New request</button>
      <button (click)="closeDialog()" *ngIf="offerResponse.errorMessage"
          kendoButton primary="true" i18n="Dialogs|'Close' button">Close</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</div>

